import {Socket, Presence} from "phoenix"

let userToken = null;
let userTokenMeta = document.querySelector("meta[name='user-token']");
if (userTokenMeta) {
  userToken = userTokenMeta.getAttribute("content");
}

let visitorId = null;
let visitorIdMeta = document.querySelector("meta[name='visitor-id']");
if (visitorIdMeta) {
  visitorId = visitorIdMeta.getAttribute("content");
}

let socket = new Socket("/socket", {params: {token: userToken, visitor_id: visitorId}});

function setupChannel(channelName, params) {
  socket.connect();

  let channel = socket.channel(channelName, {});
  let presence = new Presence(channel);

  return {channel, presence};
}

export { socket as userSocket, setupChannel };
